import { jsxs as r, Fragment as i, jsx as t } from "react/jsx-runtime";
const n = {
  WS: {
    featureList: [
      { title: "AI Powered Projections" },
      { title: "AI Powered Probabilities" },
      { title: "Easy Visualised Trends" },
      { title: "...and more" }
    ],
    header: (e) => "More Intelligent, More Profitable, More Often",
    logoAlt: "WhoScored",
    logoSrc: (e) => `${e}/assets/img/ws-logo-white.png`,
    tagline: (e) => "With over 41 million data points every week on WhoScored now powered by provably accurate AI projections, WhoScored+ helps you win more, more often with your soccer betting.",
    showAgreeTermsAsCheckbox: !0,
    showMarketingConsent: !0,
    termsAndConditionsUrl: (e) => `${e}/termsofuse`,
    privacyPolicyUrl: (e) => `${e}/privacy`,
    showSocialLogin: !1,
    featureListIcon: "square-check"
  },
  US: {
    featureList: [
      { title: "Positive Expected Value Bets" },
      { title: "AI Probabilities for each bet" },
      { title: "Public Betting Splits" },
      { title: "Trends and insights" },
      { title: "Custom Betslip" }
    ],
    logoSrc: (e) => `${e}/assets/img/oc-pro-logo.svg`,
    logoAlt: "Oddschecker",
    header: (e) => e("CX_OCPLUS_AUTH_HEADER"),
    tagline: (e) => e("CX_OCPLUS_AUTH_TAGLINE"),
    featureListIcon: "circle-check",
    showAgreeTermsAsCheckbox: !1,
    showMarketingConsent: !1,
    termsAndConditionsUrl: (e) => `${e}/terms-and-conditions`,
    privacyPolicyUrl: (e) => `${e}/privacy`,
    showSocialLogin: !0
  },
  OC: {
    featureList: [
      { title: "Positive Expected Value Bets" },
      { title: "AI Probabilities for each bet" },
      { title: "Public Betting Splits" },
      { title: "Trends and insights" },
      { title: "Custom Betslip" }
    ],
    logoSrc: (e) => `${e}/assets/img/oc-pro-logo.svg`,
    logoAlt: "Oddschecker",
    header: (e) => e("CX_OCPLUS_AUTH_HEADER"),
    tagline: (e) => e("CX_OCPLUS_AUTH_TAGLINE"),
    featureListIcon: "circle-check",
    showAgreeTermsAsCheckbox: !0,
    showMarketingConsent: !0,
    termsAndConditionsUrl: (e) => `${e}/myoddschecker/terms-and-conditions`,
    privacyPolicyUrl: (e) => `${e}/myoddschecker/privacy`,
    showSocialLogin: !0
  },
  GZ: {
    featureList: [
      { title: "Positive Expected Value Bets" },
      { title: "AI Probabilities for each bet" },
      { title: "Public Betting Splits" },
      { title: "Trends and insights" },
      { title: "Custom Betslip" }
    ],
    logoSrc: (e) => `${e}/assets/img/oc-pro-logo.svg`,
    logoAlt: "Oddschecker",
    header: (e) => e("CX_OCPLUS_AUTH_HEADER"),
    tagline: (e) => e("CX_OCPLUS_AUTH_TAGLINE"),
    featureListIcon: "circle-check",
    showAgreeTermsAsCheckbox: !0,
    showMarketingConsent: !0,
    termsAndConditionsUrl: (e) => `${e}/myoddschecker/terms-and-conditions`,
    privacyPolicyUrl: (e) => `${e}/myoddschecker/privacy`,
    showSocialLogin: !1
  }
}, l = {
  GZ: {
    comparisonBetsLabel: () => "% di scommesse 1X2",
    comparisonMoneyLabel: () => "% di distribuzione monetaria 1X2",
    // TODO: Revert to 'Serie A' after World Cup 2026
    defaultEventDisplayName: "World Cup 2026"
  },
  OC: {
    comparisonBetsLabel: (e) => `% of ${e} Bets`,
    comparisonMoneyLabel: (e) => `% of ${e} Money`,
    // TODO: Revert to 'EPL' after World Cup 2026
    defaultEventDisplayName: "World Cup 2026"
  },
  US: {
    comparisonBetsLabel: (e) => `% of ${e} Bets`,
    comparisonMoneyLabel: (e) => `% of ${e} Money`,
    // TODO: Revert to 'NFL' after World Cup 2026
    defaultEventDisplayName: "World Cup 2026"
  },
  WS: {
    comparisonBetsLabel: (e) => `% of ${e} Bets`,
    comparisonMoneyLabel: (e) => `% of ${e} Money`,
    // TODO: Revert to 'All' after World Cup 2026
    defaultEventDisplayName: "World Cup 2026"
  }
}, c = "EFL Champ", _ = "EFL L1", U = "EFL L2", d = "EPL", Z = "US MLS", G = "UCL", W = "UEL", $ = "Europa Conference", B = "Scottish Premiership", p = "Serie A", D = "La Liga", u = "Bundesliga", m = "Ligue 1", q = "Dutch Eredivisie", x = "Portuguese Primeira Liga", Y = "Austrian Bundesliga", h = "World Cup 2026", g = {
  WS: {
    start: Array.from(
      /* @__PURE__ */ new Set([
        h,
        d,
        G,
        W,
        c,
        _,
        U,
        B,
        D,
        u,
        p,
        m
      ])
    )
  },
  US: {
    start: Array.from(/* @__PURE__ */ new Set([h, "NFL", "NBA", "NCAAF", "NCAAB", "MLB", "WNBA", "NHL"])),
    end: Array.from(/* @__PURE__ */ new Set([d, "La Liga", u, p, m, Z, c]))
  },
  OC: {
    start: Array.from(
      /* @__PURE__ */ new Set([
        h,
        d,
        G,
        W,
        c,
        _,
        U,
        B,
        D,
        u,
        p,
        m,
        "NFL",
        "NBA",
        "NCAAF",
        "NCAAB",
        "MLS",
        "MLB",
        "WNBA",
        "NHL"
      ])
    )
  },
  GZ: {
    start: Array.from(
      /* @__PURE__ */ new Set([
        h,
        p,
        d,
        u,
        D,
        m,
        G,
        W,
        $,
        q,
        x,
        Y,
        "MLS",
        B,
        c,
        _,
        U,
        "NBA",
        "WNBA",
        "NCAAM",
        "WNCAA",
        "NHL",
        "MLB",
        "NFL",
        "NCAAF"
      ])
    )
  }
}, b = {
  GZ: {
    productName: "Gazzetta+",
    title: "Domande Frequenti",
    subtitle: "Le risposte alle domande più frequenti su Gazzetta Ai Predictor",
    questionsAndAnswers: [
      {
        heading: "Posso provare Gazzetta Ai Predictor prima di abbonarmi?",
        content: (e, o) => [
          /* @__PURE__ */ r(i, { children: [
            "Certo! Puoi attivare",
            " ",
            /* @__PURE__ */ t("button", { onClick: o, style: { textDecoration: "underline" }, children: "qui" }),
            " ",
            "la tua prova gratuita di 7 giorni attraverso l'abbonamento annuale, per accedere a tutti gli strumenti e alle metriche avanzate di Gazzetta Ai Predictor."
          ] })
        ]
      },
      {
        heading: "Usando Gazzetta Ai Predictor vincerò di più?",
        content: (e) => [
          /* @__PURE__ */ t(i, { children: "Non esistono garanzie di vincita. Con AI Predictor hai a disposizione algoritmi di IA che individuano le scommesse ad alto valore positivo, offrendoti un vantaggio rispetto a chi si affida solo all'istinto. Inoltre, grazie ai Trend puoi scoprire le opportunità con maggior potenziale a lungo termine." })
        ]
      },
      {
        heading: "Perché dovrei fidarmi di questo prodotto?",
        content: (e) => [
          /* @__PURE__ */ t(i, { children: "Questo servizio nasce dalla collaborazione de La Gazzetta dello Sport con un provider che da oltre 25 anni è un punto di riferimento internazionale nel mondo delle statistiche e della comparazione quote. L’esperienza maturata, unita a modelli di intelligenza artificiale di ultima generazione e a una base dati enorme, garantisce analisi chiare, affidabili e di qualità." }),
          /* @__PURE__ */ t(i, { children: "Se hai ancora dubbi, attiva una prova gratuita di 7 giorni attraverso l'abbonamento annuale per testarlo in prima persona. Per qualsiasi domanda, siamo a disposizione via e-mail o tramite il modulo di supporto." })
        ]
      },
      {
        heading: "Come faccio a disdire l’abbonamento a Gazzetta Ai Predictor?",
        content: (e) => [
          /* @__PURE__ */ t(i, { children: "Se non sei soddisfatto, puoi annullare la prova gratuita dopo 7 giorni senza alcun costo aggiuntivo. E se hai un abbonamento già attivo, lo puoi disdire dalla tua pagina personale" })
        ]
      },
      {
        heading: "Perché non riesco a cliccare una quota?",
        content: (e) => [
          /* @__PURE__ */ t(i, { children: "Alcune quote potrebbero risultare non cliccabili se in quel momento non è disponibile una comparazione tra più operatori. Tutte le scommesse offerte da due o più operatori saranno regolarmente cliccabili" })
        ]
      }
    ]
  },
  OC: {
    productName: "oddschecker+",
    title: "FAQs",
    subtitle: "Discover answers to frequently asked questions about oddschecker+",
    questionsAndAnswers: [
      {
        heading: "Can I try out oddschecker+ before committing?",
        content: (e) => [
          /* @__PURE__ */ r(i, { children: [
            "Absolutely! You can sign up ",
            /* @__PURE__ */ t("span", { className: e, children: "here" }),
            " for a 7-day free trial",
            ". You will have full access to our full suite of cutting-edge tools and metrics designed to help you find long-term profitability."
          ] })
        ]
      },
      {
        heading: "By using oddschecker+, am I guaranteed to win more?",
        content: (e) => [
          /* @__PURE__ */ t(i, { children: "While nothing is a guarantee, our tools leverage our proprietary AI algorithms to identify bets with positive expected value, giving you an edge over the sportsbooks. Additionally, you can utilize Public Betting Splits and trends to spot opportunities with long-term returns." })
        ]
      },
      {
        heading: "Why should I trust this product?",
        content: (e) => [
          /* @__PURE__ */ t(i, { children: "Oddschecker has a 25-plus year history as the global leader in providing value for sports bettors. Our state-of-the-art AI models, combined with our extensive experience and data, ensure you get the best value. Beyond that, the proof is with our users – check out social media, App Store reviews, and testimonials to help inform your decision." }),
          /* @__PURE__ */ r(i, { children: [
            "If you're still not convinced, try us out for free for 7 days and see for yourself. If you have any questions, feel free to reach out to us at ",
            /* @__PURE__ */ t("b", { children: "assist@oddschecker.com" }),
            " or through our contact form",
            " ",
            /* @__PURE__ */ t("a", { className: e, href: "https://oddscheckerus.zendesk.com/hc/en-us/requests/new", children: "here" }),
            ". We're on your team. Always."
          ] })
        ]
      },
      {
        heading: "How do I cancel my oddschecker+ subscription?",
        content: (e) => [
          /* @__PURE__ */ t(i, { children: "If you are not fully satisfied, you can cancel your free trial within 7 days at no charge. You can also cancel your subscription at any point to stop renewals." })
        ]
      }
    ]
  },
  US: {
    productName: "oddschecker+",
    title: "FAQs",
    subtitle: "Discover answers to frequently asked questions about oddschecker+",
    questionsAndAnswers: [
      {
        heading: "Can I try out oddschecker+ before committing?",
        content: (e) => [
          /* @__PURE__ */ r(i, { children: [
            "Absolutely! You can sign up ",
            /* @__PURE__ */ t("span", { className: e, children: "here" }),
            " for a 7-day free trial",
            ". You will have full access to our full suite of cutting-edge tools and metrics designed to help you find long-term profitability."
          ] })
        ]
      },
      {
        heading: "By using oddschecker+, am I guaranteed to win more?",
        content: (e) => [
          /* @__PURE__ */ t(i, { children: "While nothing is a guarantee, our tools leverage our proprietary AI algorithms to identify bets with positive expected value, giving you an edge over the sportsbooks. Additionally, you can utilize Public Betting Splits and trends to spot opportunities with long-term returns." })
        ]
      },
      {
        heading: "Why should I trust this product?",
        content: (e) => [
          /* @__PURE__ */ t(i, { children: "Oddschecker has a 25-plus year history as the global leader in providing value for sports bettors. Our state-of-the-art AI models, combined with our extensive experience and data, ensure you get the best value. Beyond that, the proof is with our users – check out social media, App Store reviews, and testimonials to help inform your decision." }),
          /* @__PURE__ */ r(i, { children: [
            "If you're still not convinced, try us out for free for 7 days and see for yourself. If you have any questions, feel free to reach out to us at ",
            /* @__PURE__ */ t("b", { children: "assist@oddschecker.com" }),
            " or through our contact form",
            " ",
            /* @__PURE__ */ t("a", { className: e, href: "https://oddscheckerus.zendesk.com/hc/en-us/requests/new", children: "here" }),
            ". We're on your team. Always."
          ] })
        ]
      },
      {
        heading: "How do I cancel my oddschecker+ subscription?",
        content: (e) => [
          /* @__PURE__ */ t(i, { children: "If you are not fully satisfied, you can cancel your free trial within 7 days at no charge. You can also cancel your subscription at any point to stop renewals." })
        ]
      }
    ]
  },
  WS: {
    productName: "WhoScored+",
    title: "FAQs",
    subtitle: "Discover answers to frequently asked questions about WhoScored+",
    questionsAndAnswers: [
      {
        heading: "Can I Try Out WhoScored+ before Committing?",
        content: () => [
          /* @__PURE__ */ r(i, { children: [
            "Absolutely! You can sign up",
            " for a 7-day free trial",
            ". You will have full access to our full suite of cutting-edge tools and metrics designed to help you find long-term profitability."
          ] })
        ]
      },
      {
        heading: "By Using WhoScored+, am I guaranteed to win more?",
        content: (e) => [
          /* @__PURE__ */ t(i, { children: "While nothing is a guarantee, our tools leverage our proprietary AI algorithms to identify bets with positive expected value, giving you an edge over the sportsbooks." })
        ]
      },
      {
        heading: "Why Should I Trust This Product?",
        content: (e) => [
          /* @__PURE__ */ t(i, { children: "Our state-of-the-art AI models, combined with our extensive experience and data, ensure you get the best value. Beyond that, the proof is with our users – check out social media, App Store reviews, and testimonials to help inform your decision." }),
          /* @__PURE__ */ r(i, { children: [
            "If you're still not convinced, try us out for free for 7 days and see for yourself. If you have any questions, feel free to reach out to us at",
            " ",
            /* @__PURE__ */ t("a", { className: e, href: "mailto:support@whoscored.com", children: "support@whoscored.com" }),
            ". We're on your team. Always."
          ] })
        ]
      },
      {
        heading: "How do I cancel?",
        content: (e) => [
          /* @__PURE__ */ t(i, { children: "If you are not fully satisfied, you can cancel your free trial within 7 days at no charge. You can also cancel your subscription at any point to stop renewals." })
        ]
      }
    ]
  }
}, y = {
  GZ: {
    evDescription: "La nostra IA elabora oltre 100 milioni di previsioni ogni settimana e analizza 125 milioni di variazioni di quota al giorno. Con lo strumento EV (Expected Value) ti mostriamo le giocate dove i dati indicano un vantaggio rispetto al valore delle quote. Con la nostra IA scegli il livello di rischio e scopri le quote più promettenti.",
    heroSubtitle: "La migliore IA per il betting sul mercato si unisce all'esperienza secolare de La Gazzetta dello Sport per offrirti uno strumento in grado di trovare le quote con il più alto Valore Atteso nel mercato",
    heroTitle: "Usa i dati e l'IA per passare in vantaggio",
    plansTitle: "Scegli un Piano",
    premiumTipstersDescription: "Niente guru, niente colpi di genio. I nostri modelli di intelligenza artificiale analizzano ogni giorno 125 milioni di dati, migliorano le scelte partita dopo partita e generano nuove dritte basate solo su numeri e statistiche.",
    trendsDescription: "Attraverso un'IA avanzata e milioni di dati esclusivi, hai subito a portata di mano le statistiche per fare la differenza. Scopri in pochi clic i trend di performance delle ultime 5, 10 o 20 partite, i mercati più popolari e i giocatori da tenere d'occhio. Sfrutta Gazzetta Ai Predictor per decidere la tua prossima mossa e restare in vantaggio.",
    defaultPageForSubscribedUser: (e) => `${e}/plus/value-bets`,
    productCards: [
      {
        descriptionKey: "premiumTipstersDescription",
        image: {
          alt: "Image of Premium Tipsters card",
          filename: "premium-tipsters.png",
          position: "leading"
        },
        listItems: [
          "Pronostici quotidiani generati da sistemi avanzati",
          "Profili Tipster AI con strategie e rischi differenti",
          "Performance storiche e bilancio sempre a tua disposizione"
        ],
        testId: "product-card-premium-tipsters",
        title: "Premium Tipster",
        trackingPosition: 2
      },
      {
        descriptionKey: "evDescription",
        image: {
          alt: "Image of Positive Value Bets card",
          filename: "positive-value-bets.png",
          position: "leading"
        },
        listItems: [
          "+100 pronostici e quote con EV positivo al giorno",
          "Calcolo della Probabilità AI per ogni scommessa",
          "Tutti gli operatori comparati in tempo reale",
          "Studi e approfondimenti per ogni scommessa"
        ],
        testId: "product-card-ev",
        title: "Scommesse di Valore",
        trackingPosition: 1
      },
      {
        descriptionKey: "trendsDescription",
        image: {
          alt: "Image of Trends card",
          filename: "trends.png",
          position: "leading"
        },
        listItems: ["Andamento performance", "Mercati del momento", "Giocatori rivelazione"],
        testId: "product-card-trends",
        title: "Trend",
        trackingPosition: 2
      },
      {
        descriptionKey: null,
        descriptionText: "Scopri i mercati su cui si sta giocando di più e come si stanno muovendo gli altri scomettitori; accedi ai dati in tempo reale grazie a Sportradar. Ogni giorno monitoriamo oltre 125 milioni di variazioni di quote, per offrirti le più convenienti in ogni momento. Resta in vantaggio con Gazzetta Ai Predictor!",
        image: {
          alt: "Image of Public Betting Splits card",
          filename: "public-betting-splits.png",
          position: "leading"
        },
        listItems: ["Flussi di giocata", "Flussi di denaro", "Comparazione quote"],
        testId: "product-card-pbd",
        title: "Su cosa si gioca?",
        trackingPosition: 2
      }
    ]
  },
  WS: {
    evDescription: "Combining WhoScored's rich dataset with over 100 million projections each week AND 125 million price changes each day, uncover which bets the bookies have under-estimated and where there is value in the market. Processing millions of data points instantly, our AI tool allows you to see where you may have an edge and what the best value bets will be across all European top leagues (and more).",
    heroSubtitle: "With over 41 million data points every week on WhoScored now powered by provably accurate AI projections, WhoScored+ helps you win more, more often with your soccer betting.",
    heroTitle: "More Intelligent, More Profitable, More Often.",
    plansTitle: "Step Up Your Game - Subscribe Now!",
    trendsDescription: "Supercharge your knowledge of any key player or team performance - intertwined with future-projections - to help uncover the best betting opportunities in 10+ leagues worldwide on any valid matchday. Take away the hassle of deciphering multiple key stats and performance patterns and insights with Trends' simple visualisation over the past 5, 10 or 20 games, helping accelerate your betting decisions and improving your likelihood of profitable betting.",
    defaultPageForSubscribedUser: (e) => `${e}/plus/value-bets`,
    productCards: [
      {
        descriptionKey: "trendsDescription",
        image: {
          alt: "Image of Trends card",
          filename: "trends.png",
          position: "leading"
        },
        listItems: ["Performance Trends", "Hottest Plays", "Breakout Players"],
        testId: "product-card-trends",
        title: "Trends",
        trackingPosition: 2
      },
      {
        descriptionKey: "evDescription",
        image: {
          alt: "Image of Positive Value Bets card",
          filename: "positive-value-bets.png",
          position: "trailing"
        },
        listItems: ["Best Odds Available", "Current Trends for Each Pick", "AI and Implied Probability"],
        testId: "product-card-ev",
        title: "Positive Value Bets",
        trackingPosition: 1
      }
    ]
  },
  US: {
    evDescription: "Our AI produces 100 million projections each week. We scour over 125 million price changes each day. Our Positive EV tool gives you our best plays where you have a mathematical edge over the books. We've thrown in recent trends to show you whether a pick is hot so you've got everything you need to beat the odds!",
    heroSubtitle: "25+ years of experience beating the books combined with cutting-edge AI geared to help you win.",
    heroTitle: "Bet Smarter With Industry-leading data and ai",
    plansTitle: "Plans",
    trendsDescription: "Our AI models, intertwined with market-leading data, enable you access to in-depth statistical analysis in an instant and digestible form. Identify the best betting opportunities with easy navigation and intuitive visualization of the key stats and performance trends over the past 5, 10 or 20 games, as well as pulling out the hottest props and breakout players. Gain a breakdown of recent games across all key stats that could factor into your bet.",
    defaultPageForSubscribedUser: (e) => `${e}/plus/positive-ev`,
    productCards: [
      {
        descriptionKey: "trendsDescription",
        image: {
          alt: "Image of Trends card",
          filename: "trends.png",
          position: "leading"
        },
        listItems: ["Performance Trends", "Hottest Plays", "Breakout Players"],
        testId: "product-card-trends",
        title: "Trends",
        trackingPosition: 2
      },
      {
        descriptionKey: "evDescription",
        image: {
          alt: "Image of Positive Value Bets card",
          filename: "positive-value-bets.png",
          position: "trailing"
        },
        listItems: ["Best Odds Available", "Current Trends for Each Pick", "AI and Implied Probability"],
        testId: "product-card-ev",
        title: "Positive Value Bets",
        trackingPosition: 1
      },
      {
        descriptionKey: null,
        descriptionText: "Spot the difference between the public and big money sharps! Get the most up-to-date betting splits powered by Sportradar, the official data provider for the MLB, NBA, and NHL. We monitor 125 million price changes each day, so you always catch the best odds. Stay one step ahead with oddschecker+!",
        image: {
          alt: "Image of Public Betting Splits card",
          filename: "public-betting-splits.png",
          position: "leading"
        },
        listItems: ["Public Bet %", "Public Money %", "Best Odds Across All Sportsbooks"],
        testId: "product-card-pbd",
        title: "Public Betting Splits",
        trackingPosition: 2
      }
    ]
  },
  OC: {
    evDescription: "Our AI produces 100 million projections each week. We scour over 125 million price changes each day. Our Positive EV tool gives you our best plays where you have a mathematical edge over the books. We've thrown in recent trends to show you whether a pick is hot so you've got everything you need to beat the odds!",
    heroSubtitle: "25+ years of experience beating the books combined with cutting-edge AI geared to help you win.",
    heroTitle: "Bet Smarter With Industry-leading data and ai",
    plansTitle: "Plans",
    trendsDescription: "Our AI models, intertwined with market-leading data, enable you access to in-depth statistical analysis in an instant and digestible form. Identify the best betting opportunities with easy navigation and intuitive visualization of the key stats and performance trends over the past 5, 10 or 20 games, as well as pulling out the hottest props and breakout players. Gain a breakdown of recent games across all key stats that could factor into your bet.",
    defaultPageForSubscribedUser: (e) => `${e}/plus/value-bets`,
    productCards: [
      {
        descriptionKey: "trendsDescription",
        image: {
          alt: "Image of Trends card",
          filename: "trends.png",
          position: "leading"
        },
        listItems: ["Performance Trends", "Hottest Plays", "Breakout Players"],
        testId: "product-card-trends",
        title: "Trends",
        trackingPosition: 2
      },
      {
        descriptionKey: "evDescription",
        image: {
          alt: "Image of Positive Value Bets card",
          filename: "positive-value-bets.png",
          position: "trailing"
        },
        listItems: ["Best Odds Available", "Current Trends for Each Pick", "AI and Implied Probability"],
        testId: "product-card-ev",
        title: "Positive Value Bets",
        trackingPosition: 1
      },
      {
        descriptionKey: null,
        descriptionText: "Spot the difference between the public and big money sharps! Get the most up-to-date betting splits powered by Sportradar, the official data provider for the MLB, NBA, and NHL. We monitor 125 million price changes each day, so you always catch the best odds. Stay one step ahead with oddschecker+!",
        image: {
          alt: "Image of Public Betting Splits card",
          filename: "public-betting-splits.png",
          position: "leading"
        },
        listItems: ["Public Bet %", "Public Money %", "Best Odds Across All Sportsbooks"],
        testId: "product-card-pbd",
        title: "Public Betting Splits",
        trackingPosition: 2
      }
    ]
  }
}, f = {
  GZ: {
    // TODO: Revert to 'Serie A' after World Cup 2026
    defaultEventDisplayName: "World Cup 2026",
    matchCenterLabel: "Match Center",
    matchCenterPath: "match-centre"
  },
  OC: {
    // TODO: Revert to 'EPL' after World Cup 2026
    defaultEventDisplayName: "World Cup 2026",
    matchCenterLabel: "Match Centre",
    matchCenterPath: "match-centre"
  },
  US: {
    // TODO: Revert to 'NFL' after World Cup 2026
    defaultEventDisplayName: "World Cup 2026",
    matchCenterLabel: "Match Center",
    matchCenterPath: "match-center"
  },
  WS: {
    // TODO: Revert to 'All' after World Cup 2026
    defaultEventDisplayName: "World Cup 2026",
    matchCenterLabel: "Match Centre",
    matchCenterPath: "match-centre"
  }
}, S = {
  WS: "/plus",
  US: "/us/plus",
  OC: "/plus",
  GZ: "/plus"
}, K = {
  WS: [
    "event-overview",
    "match-centre",
    "player",
    "premium-market-movers",
    "premium-tipsters",
    "public-betting-data",
    "tipster"
  ]
}, v = {
  WS: {
    plusLinks: (e) => [
      {
        href: `${e}value-bets`,
        link: "Value Bets"
      },
      {
        href: `${e}trends`,
        link: "Trends"
      }
    ]
  },
  US: {
    plusLinks: (e) => [
      {
        href: `${e}positive-ev`,
        link: "Positive Value Bets"
      },
      {
        href: `${e}betting-splits`,
        link: "Public Betting Splits"
      },
      {
        href: `${e}trends`,
        link: "Trends"
      },
      {
        href: `${e}match-center`,
        link: "Match Center"
      },
      {
        href: `${e}premium-picks`,
        link: "Premium Picks",
        showWhenTipstersEnabled: !1
      }
    ]
  },
  GZ: {
    plusLinks: (e) => [
      {
        href: `${e}value-bets`,
        link: "Scommesse di Valore"
      },
      {
        href: `${e}trends`,
        link: "Trend"
      },
      {
        href: `${e}betting-splits`,
        link: "Scelte degli scommettitori"
      },
      {
        href: `${e}match-centre`,
        link: "Match Center"
      },
      {
        href: `${e}premium-tipsters`,
        link: "Premium Tipster",
        showWhenTipstersEnabled: !0
      }
    ]
  },
  OC: {
    plusLinks: (e) => [
      {
        href: `${e}value-bets`,
        link: "Value Bets"
      },
      {
        href: `${e}betting-splits`,
        link: "Public Betting Splits"
      },
      {
        href: `${e}trends`,
        link: "Trends"
      },
      {
        href: `${e}premium-tipsters`,
        link: "Premium Tipsters",
        showWhenTipstersEnabled: !1
      },
      {
        href: `${e}horse-racing/premium-market-movers`,
        link: "Premium Market Movers"
      },
      {
        href: `${e}match-centre`,
        link: "Match Centre"
      }
    ]
  }
}, P = {
  WS: {
    ctaText: "Start 7-Day Free Trial",
    padlockImage: "padlock-ws.svg",
    title: /* @__PURE__ */ r(i, { children: [
      "BET WITH MORE INTELLIGENCE, MORE PROFITABLY,",
      /* @__PURE__ */ t("br", {}),
      " MORE OFTEN WITH WHOSCORED+"
    ] }),
    description: "With over 41 million data points every week on WhoScored now powered by provably accurate AI projections, WhoScored+ helps you win more, more often with your soccer betting.",
    isSinglePriceTier: !0,
    pricingLabel: "Professional insights",
    ctaClickTrackingProductName: "WhoScored Premium",
    dataTemplate: "whoscored",
    loginText: "Already subscribed? Please ",
    cssClass: "wsPaywallCard",
    testId: "ws-paywall",
    shouldCtaClickOpenModal: !0,
    hasProductSelection: !1
    // WS has only one product option (Premium Monthly)
  },
  US: {
    ctaText: "Start 7-Day Free Trial",
    padlockImage: "padlock.svg",
    description: "Bet smarter with our full suite of cutting-edge tools and metrics designed to help you find long-term profitability.",
    hasProductSelection: !0,
    // US: user selects between Monthly and Annual Premium
    pricingLabel: "Less than £1 per day",
    ctaClickTrackingProductName: "Premium",
    loginText: "Already subscribed? Please ",
    title: /* @__PURE__ */ r(i, { children: [
      "Gain access to ",
      /* @__PURE__ */ t("br", {}),
      "Industry-Leading Data and AI"
    ] }),
    cssClass: "padlockCard",
    testId: "component-wall",
    shouldCtaClickOpenModal: !1,
    isSinglePriceTier: !0
  },
  GZ: {
    ctaText: "Inizia la prova gratuita di 14 giorni",
    padlockImage: "padlock.svg",
    description: "Scommetti in modo più intelligente con la nostra suite completa di strumenti e metriche all'avanguardia progettati per aiutarti a trovare la redditività a lungo termine.",
    hasProductSelection: !0,
    pricingLabel: "Meno di €1 al giorno",
    ctaClickTrackingProductName: "Premium",
    loginText: "Sei già iscritto?",
    title: /* @__PURE__ */ t(i, { children: "Ottieni accesso a dati e intelligenza artificiale leader del settore" }),
    cssClass: "padlockCard",
    testId: "component-wall",
    shouldCtaClickOpenModal: !1,
    isSinglePriceTier: !0
  },
  OC: {
    ctaText: "Start 7-Day Free Trial",
    padlockImage: "padlock.svg",
    description: "Bet smarter with our full suite of cutting-edge tools and metrics designed to help you find long-term profitability.",
    hasProductSelection: !0,
    // OC: user selects between Essential/Premium tiers AND Monthly/Annual terms
    pricingLabel: "Less than £1 per day",
    ctaClickTrackingProductName: "Premium",
    loginText: "Have you already subscribed? Please ",
    title: "Gain access to Industry-Leading Data and AI",
    cssClass: "globalPaywallCard",
    testId: "global-paywall",
    shouldCtaClickOpenModal: !0,
    isSinglePriceTier: !1
  }
}, a = {
  ESSENTIAL_MONTHLY: "prod_RqTbYsPalQ3AfM",
  ESSENTIAL_ANNUALLY: "prod_RqTezToe62ITrO",
  PREMIUM_MONTHLY: "prod_QkHK6SYqqUnkLC",
  PREMIUM_ANNUALLY: "prod_QkHLnJhTVhERhy",
  WHOSCORED_PLUS_MONTHLY: "prod_SsACNCOh4v7G84",
  GAZZETTA_PLUS_MONTHLY: "prod_GZ_PLUS_MONTHLY",
  // This Stripe product ID retains the legacy 'ANNUAL' suffix from when it was an annual plan.
  // The underlying Stripe product has been repurposed as a 3-month prepaid plan.
  GAZZETTA_PLUS_THREE_MONTHLY: "prod_GZ_PLUS_ANNUAL"
}, C = {
  WS: {
    premiumFeatures: [
      { title: "AI-powered projections" },
      { title: "AI-powered probabilities" },
      { title: "Easy Visualised Trends" }
    ],
    products: {
      [a.WHOSCORED_PLUS_MONTHLY]: {
        name: "WhoScored+",
        term: "monthly",
        isDefaultWhenSingleOption: !0
      }
    }
  },
  US: {
    premiumFeatures: [
      { title: "Positive Expected Value Bets" },
      { title: "AI Probabilities for each bet" },
      { title: "Public Betting Splits" },
      { title: "Trends and insights for Each Bet" },
      { title: "Custom Betslip" }
    ],
    products: {
      [a.PREMIUM_ANNUALLY]: { name: "Premium", term: "annually", isDefaultWhenSingleOption: !1 },
      [a.PREMIUM_MONTHLY]: { name: "Premium", term: "monthly", isDefaultWhenSingleOption: !0 }
    }
  },
  OC: {
    essentialFeatures: [
      {
        title: "Unlimited Grids",
        description: "Unlock unlimited comparison grids for over 500 sporting events daily"
      },
      {
        title: "Market Movers",
        description: "Unlock unlimited access to the top steamers and drifters daily"
      },
      {
        title: "Reduced Ads",
        description: "Never see banner advertising or popups again"
      },
      {
        title: "Price History",
        description: "Get unlimited access to price history across 25+ bookmakers"
      },
      {
        title: "Free Racehorse Share",
        description: "Claim an exclusive FREE racehorse share worth £40!"
      },
      {
        title: "Premium Content",
        isDisabled: !0
      },
      {
        title: "60% off RacingTV",
        isDisabled: !0
      },
      {
        title: "Value Bets",
        isDisabled: !0
      },
      {
        title: "Trends",
        isDisabled: !0
      },
      {
        title: "Public Betting Splits",
        isDisabled: !0
      }
    ],
    premiumFeatures: [
      {
        title: "Unlimited Grids",
        description: "Unlock unlimited comparison grids for over 500 sporting events daily"
      },
      {
        title: "AI Probabilities on Grids",
        description: "Visibility of our cutting edge AI probabilities on supported sporting events and markets"
      },
      {
        title: "Market Movers",
        description: "Unlock unlimited access to the top steamers and drifters daily"
      },
      {
        title: "Reduced Ads",
        description: "Never see banner advertising or popups again"
      },
      {
        title: "Price History",
        description: "Get unlimited access to price history across 25+ bookmakers"
      },
      {
        title: "Free Racehorse Share",
        description: "Claim an exclusive FREE racehorse share worth £40!"
      },
      {
        title: "Premium Content",
        description: "Unlock exclusive access to Andy Holding, Ginger Joe, Liam Firkin & more"
      },
      {
        title: "60% off RacingTV",
        description: "Get an exclusive 60% off RacingTV subscription at £11.99 per month for 12 months. Available to new and returning RacingTV customers"
      },
      {
        title: "Value Bets",
        description: "Get access to our Value Bets tool powered by cutting edge AI"
      },
      {
        title: "Trends",
        description: "Identify the best betting opportunities with our AI powered Trends"
      },
      {
        title: "Public Betting Splits",
        description: "Get access to where the smart money is going"
      }
    ],
    products: {
      [a.ESSENTIAL_MONTHLY]: {
        name: "Essential",
        term: "monthly",
        isDefaultWhenSingleOption: !1
      },
      [a.ESSENTIAL_ANNUALLY]: {
        name: "Essential",
        term: "annually",
        isDefaultWhenSingleOption: !1
      },
      [a.PREMIUM_ANNUALLY]: { name: "Premium", term: "annually", isDefaultWhenSingleOption: !1 },
      [a.PREMIUM_MONTHLY]: { name: "Premium", term: "monthly", isDefaultWhenSingleOption: !0 }
    }
  },
  GZ: {
    premiumFeatures: [
      { title: "+100 pronostici e quote con EV positivo al giorno" },
      { title: "Calcolo della Probabilità AI per ogni scommessa" },
      { title: "Tutti gli operatori comparati in tempo reale" },
      { title: "Studi e approfondimenti per ogni scommessa" }
    ],
    products: {
      [a.GAZZETTA_PLUS_MONTHLY]: {
        externalUrl: {
          NON_PROD: "https://dev.abbonamenti.gazzetta.it/login/?OfferId=OFF-00136830_1&returnUrl=https://dv1-fpsm.gazzetta.it&pwcmp=AIPREDMensile",
          PROD: "https://abbonamenti.gazzetta.it/login/?OfferId=OFF-00136830_1&returnUrl=https://aipredictor.gazzetta.it&pwcmp=AIPREDMensile"
        },
        isDefaultWhenSingleOption: !0,
        name: "Premium",
        term: "monthly"
      },
      [a.GAZZETTA_PLUS_THREE_MONTHLY]: {
        externalUrl: {
          NON_PROD: "https://dev.abbonamenti.gazzetta.it/login/?OfferId=OFF-00137715_1&returnUrl=https://dv1-fpsm.gazzetta.it&pwcmp=AIPREDMondOdds",
          PROD: "https://abbonamenti.gazzetta.it/login/?OfferId=OFF-00137715_1&returnUrl=https://aipredictor.gazzetta.it&pwcmp=AIPREDMondOdds"
        },
        isDefaultWhenSingleOption: !1,
        name: "Premium",
        term: "monthly"
      }
    }
  }
}, z = {
  GZ: {
    path: "premium-tipsters",
    ui: {
      pointsUnit: "pts"
    }
  },
  OC: {
    path: "premium-tipsters"
  },
  US: {
    path: "premium-picks"
  }
}, I = {
  GZ: {
    landingSubscriptionClick: {
      eventName: "landing_page_cta",
      getEventData: ({ price: e, term: o }) => ({
        eventLabel: "Landing Page CTA",
        product: e,
        selection: o
      })
    }
  },
  OC: {
    landingSubscriptionClick: {
      eventName: "landing_page_cta",
      getEventData: ({ isUpgrade: e, price: o, selection: N, term: M }) => ({
        eventLabel: e ? "Plan Upgrade CTA" : "Landing Page CTA",
        product: `${M} - ${o}`,
        referrerUrl: document.referrer,
        upgradeOrPurchase: e ? "Upgrade" : "Purchase",
        ...e ? {} : { selection: N }
      })
    }
  },
  US: {
    landingSubscriptionClick: {
      eventName: "landing_page_cta",
      getEventData: ({ price: e, term: o }) => ({
        eventLabel: "Landing Page CTA",
        product: e,
        selection: o
      })
    }
  },
  WS: {
    landingSubscriptionClick: {
      eventName: "landing_page_cta",
      getEventData: ({ price: e, term: o }) => ({
        eventLabel: "Landing Page CTA",
        product: e,
        selection: o
      })
    }
  }
}, A = {
  GZ: {
    // TODO: Revert to 'Serie A' after World Cup 2026
    defaultEventDisplayName: "World Cup 2026",
    last5: "Ultime 5",
    last10: "Ultime 10",
    last20: "Ultime 20"
  },
  OC: {
    // TODO: Revert to 'EPL' after World Cup 2026
    defaultEventDisplayName: "World Cup 2026",
    last5: "Last 5",
    last10: "Last 10",
    last20: "Last 20"
  },
  US: {
    // TODO: Revert to 'NFL' after World Cup 2026
    defaultEventDisplayName: "World Cup 2026",
    last5: "Last 5",
    last10: "Last 10",
    last20: "Last 20"
  },
  WS: {
    // TODO: Revert to 'All' after World Cup 2026
    defaultEventDisplayName: "World Cup 2026",
    last5: "Last 5",
    last10: "Last 10",
    last20: "Last 20"
  }
  // ES: {
  //   defaultEventDisplayName: 'All',
  //   last5: 'Últimos 5',
  //   last10: 'Últimos 10',
  //   last20: 'Últimos 20',
  // },
}, k = {
  WS: {
    theme: "whoscored"
  },
  US: {
    theme: "plus"
  },
  OC: {
    theme: "plus"
  },
  GZ: {
    theme: "gazzetta"
  }
}, O = {
  WS: {
    alt: "WhoScored",
    src: (e) => `${e}/assets/img/ws-logo-white.png`,
    style: { maxWidth: "180px", maxHeight: "75px" }
  },
  US: {
    alt: "OddsChecker",
    src: (e) => `${e}/assets/img/oc-pro-logo.svg`,
    style: {}
  },
  OC: {
    alt: "OddsChecker",
    src: (e) => `${e}/assets/img/oc-pro-logo.svg`,
    style: {}
  },
  GZ: {
    alt: "Gazetta",
    src: (e) => `${e}/assets/img/gazzetta-logo.svg`,
    mobileSrc: (e) => `${e}/assets/img/gazzetta-logo-mobile.svg`,
    style: {}
  }
}, V = {
  WS: {
    backgroundColor: "#2d2d2d",
    customComponent: "ErrorWhoScored"
  },
  GZ: {
    backgroundColor: "#f5f5f5",
    redirectUrl: "https://www.gazzetta.it/404.shtml"
  }
}, j = {
  WS: "https://www.whoscored.com"
}, w = {
  GZ: {
    // TODO: Revert to 'Serie A' after World Cup 2026
    defaultEventDisplayName: "World Cup 2026",
    defaultSortBy: "search-ev-bets_sportsbookProbability_desc",
    aiProbability: "Probabilità IA",
    aiProbabilityShort: "Probabilità IA",
    aiProbabilityTooltip: "La probabilità, stimata dalla nostra piattaforma AI, che la giocata si avveri rispetto alle aspettative dei bookmaker",
    impliedProbability: "Probabilità Implicita",
    impliedProbabilityShort: "Probabilità Implicita",
    impliedProbabilityTooltip: "La probabilità che la giocata si avveri, secondo il bookmaker con la quota migliore",
    expectedValue: "EV",
    expectedValueTooltip: "ROI previsto per questa giocata, stimato dal nostro modello AI predittivo. >0% - Conveniente, <0% = Non Conveniente, >10% = Molto Conveniente"
  },
  OC: {
    // TODO: Revert to 'EPL' after World Cup 2026
    defaultEventDisplayName: "World Cup 2026",
    defaultSortBy: "search-ev-bets_sportsbookProbability_desc",
    aiProbability: "AI Probability",
    aiProbabilityShort: "AI Prob",
    aiProbabilityTooltip: "The % likelihood a projection will cover the consensus line based on our proprietary AI platform",
    impliedProbability: "Implied Probability",
    impliedProbabilityShort: "Im. Prob",
    impliedProbabilityTooltip: "Implied probability the bet will win based on the sportsbook with best odds",
    expectedValue: "EV",
    expectedValueTooltip: "The average ROI a bettor can expect for this bet based on our AI predictive model. >0% - Profitable Bet, <0% = Unprofitable Bet, >10% = Highly Profitable Bet"
  },
  US: {
    // TODO: Revert to 'NFL' after World Cup 2026
    defaultEventDisplayName: "World Cup 2026",
    defaultSortBy: "search-ev-bets_expectedValue_desc",
    aiProbability: "AI Probability",
    aiProbabilityShort: "AI Prob",
    aiProbabilityTooltip: "The % likelihood a projection will cover the consensus line based on our proprietary AI platform",
    impliedProbability: "Implied Probability",
    impliedProbabilityShort: "Im. Prob",
    impliedProbabilityTooltip: "Implied probability the bet will win based on the sportsbook with best odds",
    expectedValue: "EV",
    expectedValueTooltip: "The average ROI a bettor can expect for this bet based on our AI predictive model. >0% - Profitable Bet, <0% = Unprofitable Bet, >10% = Highly Profitable Bet"
  },
  WS: {
    // TODO: Revert to 'All' after World Cup 2026
    defaultEventDisplayName: "World Cup 2026",
    defaultSortBy: "search-ev-bets_sportsbookProbability_desc",
    aiProbability: "AI Prob",
    aiProbabilityShort: "AI Probability",
    aiProbabilityTooltip: "The % likelihood a projection will cover the consensus line based on our proprietary AI platform",
    impliedProbability: "Implied Probability",
    impliedProbabilityShort: "Im. Prob",
    impliedProbabilityTooltip: "Implied probability the bet will win based on the sportsbook with best odds",
    expectedValue: "EV",
    expectedValueTooltip: "The average ROI a bettor can expect for this bet based on our AI predictive model. >0% - Profitable Bet, <0% = Unprofitable Bet, >10% = Highly Profitable Bet"
  }
  // ES: {
  //   defaultEventDisplayName: 'All',
  //   defaultSortBy: 'search-ev-bets_sportsbookProbability_desc',
  //   aiProbability: 'Probabilidad según IA',
  //   aiProbabilityShort: '', // UPDATE WHEN WE HAVE TRANSLATIONS
  //   aiProbabilityTooltip: '', // UPDATE WHEN WE HAVE TRANSLATIONS
  //   impliedProbability: 'Probabilidad implícita',
  //   impliedProbabilityShort: '', // UPDATE WHEN WE HAVE TRANSLATIONS
  //   impliedProbabilityTooltip: '', // UPDATE WHEN WE HAVE TRANSLATIONS
  //   expectedValue: 'VE',
  //   expectedValueTooltip: '', // UPDATE WHEN WE HAVE TRANSLATIONS
  // },
}, s = {
  WS: {
    auth: n.WS,
    bettingSplits: l.WS,
    matchupCentre: f.WS,
    categoryOrdering: g.WS,
    errorPage: V.WS,
    faq: b.WS,
    landingPage: y.WS,
    logo: O.WS,
    logoUrl: j.WS,
    navigation: v.WS,
    name: "WhoScored",
    paywall: P.WS,
    plusHomePagePath: S.WS,
    plusToolsRestricted: K.WS,
    subscription: C.WS,
    tracking: I.WS,
    trends: A.WS,
    valueBets: w.WS,
    oddsFormatCookieKey: "ws-of",
    oddsFormatMap: {
      0: "decimal",
      1: "fractional",
      2: "american"
    },
    uiBehavior: k.WS
  },
  US: {
    auth: n.US,
    bettingSplits: l.US,
    categoryOrdering: g.US,
    faq: b.US,
    matchupCentre: f.US,
    landingPage: y.US,
    logo: O.US,
    name: "Oddschecker",
    navigation: v.US,
    paywall: P.US,
    plusHomePagePath: S.US,
    subscription: C.US,
    tracking: I.US,
    trends: A.US,
    tipsters: z.US,
    valueBets: w.US,
    oddsFormatCookieKey: "odds_format",
    uiBehavior: k.US
  },
  OC: {
    auth: n.OC,
    bettingSplits: l.OC,
    categoryOrdering: g.OC,
    faq: b.OC,
    matchupCentre: f.OC,
    landingPage: y.OC,
    logo: O.OC,
    name: "Oddschecker",
    navigation: v.OC,
    paywall: P.OC,
    plusHomePagePath: S.OC,
    subscription: C.OC,
    tracking: I.OC,
    trends: A.OC,
    tipsters: z.OC,
    valueBets: w.OC,
    oddsFormatCookieKey: "odds_type",
    uiBehavior: k.OC
  },
  GZ: {
    auth: n.GZ,
    bettingSplits: l.GZ,
    categoryOrdering: g.GZ,
    errorPage: V.GZ,
    faq: b.GZ,
    landingPage: y.GZ,
    logo: O.GZ,
    matchupCentre: f.GZ,
    name: "Gazzetta",
    navigation: v.GZ,
    paywall: P.GZ,
    plusHomePagePath: S.GZ,
    subscription: C.GZ,
    tracking: I.GZ,
    trends: A.GZ,
    valueBets: w.GZ,
    tipsters: z.GZ,
    oddsFormatCookieKey: "odds_type",
    uiBehavior: k.GZ
  }
}, T = {
  WS: "ws-favicon.svg",
  OC: "oc-favicon.svg",
  US: "us-favicon.png",
  GZ: "gz-favicon.ico"
}, L = {
  APPLE: "apple",
  GOOGLE: "google",
  ODDSCHECKER: "oddschecker",
  WHOSCORED: "whoscored"
}, E = {
  WS: {
    authProvider: L.WHOSCORED
  },
  OC: {
    authProvider: L.ODDSCHECKER
  },
  US: {
    authProvider: L.ODDSCHECKER
  },
  GZ: {
    authProvider: L.ODDSCHECKER,
    usesConsentGatedGTM: !0,
    skipFingerprintScripts: !0
  }
}, J = ({
  isTipstersEnabled: e,
  repub: o,
  urlPrefix: N
}) => {
  var R, F;
  return (((F = (R = s[o]) == null ? void 0 : R.navigation) == null ? void 0 : F.plusLinks(N)) ?? []).filter((H) => H.showWhenTipstersEnabled === !0 ? e : H.showWhenTipstersEnabled !== !1);
}, Q = {
  WS: {
    favicon: T.WS,
    plus: s.WS,
    tracking: E.WS
  },
  OC: {
    favicon: T.OC,
    plus: s.OC,
    tracking: E.OC
  },
  US: {
    favicon: T.US,
    plus: s.US,
    tracking: E.US
  },
  GZ: {
    favicon: T.GZ,
    plus: s.GZ,
    tracking: E.GZ
  }
};
function ee(e) {
  return Object.keys(Q).includes(e);
}
export {
  l as BETTING_SPLITS_CONFIGS,
  g as CATEGORY_ORDERING_CONFIGS,
  S as PLUS_HOME_PAGE_PATHS,
  s as PLUS_REPUB_CONFIG,
  Q as REPUB_CONFIG,
  a as STRIPE_PRODUCT_IDS,
  C as SUBSCRIPTION_CONFIGS,
  A as TRENDS_CONFIGS,
  w as VALUE_BETS_CONFIGS,
  L as authProviders,
  J as getPlusLinks,
  ee as isSupportedRepub
};
